/**
 * Score write-back on close (roadmap 1C, V-5): every close path calls this
 * after the session's result is saved. It runs the one write-back path
 * (src/lib/sessionScoreWriteBack.ts) and shows its plain result line. It never
 * blocks the close — the session's result is already saved.
 */

import { useCallback } from 'react';
import { useToast } from '../../components/ui/Toast';
import { writeBackNotice, writeBackScoresOnClose, type WriteBackOnCloseInput } from '../../lib/sessionScoreWriteBack';

export function useWriteBackOnClose() {
  const { showToast } = useToast();
  return useCallback(
    async (input: WriteBackOnCloseInput) => {
      const notice = writeBackNotice(await writeBackScoresOnClose(input));
      if (notice) showToast(notice.type, notice.title, notice.message, 12000);
    },
    [showToast],
  );
}
